import React, { useState } from 'react';
import { Modal, Box, TextField, Typography, Button } from '@mui/material';
import { updateGroupName } from '../../../../repository/OrganizationDAO';
import { useUserContext } from '../../../../context_providers/user_context/UserProvider';
import LoadingData from '../../../../components/loading/LoadingData';
import { useToast } from '../../../../context_providers/toast_context/ToastContext';
import COLORS from '../../../../resources/style/Themes';
import { useTranslation } from 'react-i18next';
import {
  ErrorStringKeys,
  StringKeys,
  SuccessStringKeys,
} from '../../../../resources/strings/StringKeys';
import { isReservedAllUsersGroupName } from '../allUsersConstants';

function EditGroupNameModal({ onHide, show, group, organization, navigate }) {
  const { bearerToken } = useUserContext();
  const [newGroupName, setNewGroupName] = useState('');
  const [loading, setLoading] = useState(false);
  const { showErrorToast, showSuccessToast } = useToast();
  const { t } = useTranslation();

  const handleChangeNameLocal = async () => {
    try {
      setLoading(true);
      if (newGroupName === '') {
        showErrorToast(t(StringKeys.PLEASE_ENTER_A_VALUE_FOR_NEW_GROUP_NAME));
        return;
      }
      if (isReservedAllUsersGroupName(newGroupName)) {
        showErrorToast(t(StringKeys.GROUP_NAME_RESERVED_FOR_ALL_USERS_PAGE));
        return;
      }
      await updateGroupName(
        organization.org_code,
        group,
        newGroupName,
        organization.id,
      );
      showSuccessToast(t(SuccessStringKeys.SUCCESSFULLY_UPDATED_GROUP_NAME));
      navigate(newGroupName);
      onHide();
    } catch (error) {
      showErrorToast(t(ErrorStringKeys.FAILED_TO_UPDATE_GROUP_NAME));
    } finally {
      setLoading(false);
    }
  };

  if (!organization || !onHide || !show || !group) {
    return null;
  }

  return (
    <>
      <Modal
        open={show}
        onClose={onHide}
        aria-labelledby="edit-group-name-modal-title"
        aria-describedby="edit-group-name-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography
            id="edit-group-name-modal-title"
            variant="h6"
            sx={{
              backgroundColor: COLORS.SAFEGUARD_BLUE,
              color: COLORS.WHITE,
              p: 2,
              borderRadius: '4px 4px 0 0',
            }}
          >
            {t(StringKeys.UPDATE_GROUP_NAME, { group: `${group.group_name}` })}
          </Typography>
          <Box sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label={t(StringKeys.NEW_GROUP_NAME)}
              variant="outlined"
              value={newGroupName}
              onChange={(e) => setNewGroupName(e.target.value)}
            />
          </Box>
          <Box sx={{ mt: 4, textAlign: 'right' }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleChangeNameLocal}
            >
              {t(StringKeys.ENTER)}
            </Button>
          </Box>
        </Box>
      </Modal>
      <LoadingData show={loading} />
    </>
  );
}

export default EditGroupNameModal;
